
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.023 5.249h3.965c.178.055.356.11.554.15l1.265.301c1.415.342 2.01.807 2.01 1.627 0 .985-1.005 1.689-2.434 1.689-1.265 0-2.208-.568-2.564-1.538-.123-.294-.273-.424-.56-.424-.363 0-.588.225-.588.58 0 .124.014.254.048.384.362 1.292 1.79 2.098 3.67 2.098 2.263 0 3.72-1.155 3.72-2.94 0-.854-.315-1.469-1.005-1.927h2.645c.157 0 .28-.123.28-.28a.277.277 0 00-.28-.28H7.825a6.514 6.514 0 00-.608-.165l-1.114-.266c-1.388-.335-1.976-.759-1.976-1.518 0-.957.943-1.634 2.249-1.634 1.176 0 2.017.534 2.352 1.477.116.26.273.383.546.383.356 0 .575-.205.575-.547 0-.103-.014-.212-.041-.315C9.5.86 8.133.006 6.376.006c-2.058 0-3.541 1.169-3.541 2.823 0 .807.3 1.408.943 1.86H1.023a.277.277 0 00-.28.28c0 .157.123.28.28.28z","fill":"#000"}})])
          )
        }
      }
    